<template>
  <div class="dataCenter-common-list">
    <div
      v-if="isShowOperate"
      class="dataCenter-common-list_operate"
    >
      <operationBtns
        ref="operationBtns"
        @clickBtn="handleCommand"
        v-bind="$attrs"
        :select-length="selectedLength"
      />
      <div
        v-if="isSupportSort"
        class="sort"
        @click="sortData"
      >
        按时间排序
        <i :class="orderTimeClass" />
      </div>
    </div>
    <commonTable
      v-bind="$attrs"
      @handleSelectionChange="handleSelectionChange"
    />
    <Cypagination
      ref="cypagination"
      v-bind="$attrs"
      @handleCurrentChange="handleCurrentChange"
    />
    <deleteDialog
      width="450px"
      ref="deleteDialog"
      class="deleteDialog"
      :is-show-footer="true"
      v-bind="$attrs"
      @dialogSure="dialogDeleteSure"
    >
      <div class="delete-icon-box">
        <i class="icon icon-warning" />
      </div>
      <div class="delete-text">
        {{ tips }}
      </div>
    </deleteDialog>
  </div>
</template>

<script>
import operationBtns from '@components/common/operationBtns'
import commonTable from '@components/dataCenter/table'
import deleteDialog from '@components/dialog/cyDialogCommon'
export default {
  name: 'ListTemplate',
  inheritAttrs: false,
  props: {
    isShowOperate: {
      type: Boolean,
      default: true
    },
    isInitList: {
      type: Boolean,
      default: true
    },
    // 是否支持时间排序
    isSupportSort: {
      type: Boolean,
      default: true
    },
    // 自定义参数
    selfDefinedParams: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    commonTable,
    operationBtns,
    deleteDialog
  },
  data() {
    return {
      page: 1,
      orderType: 'DESC',
      handleCode: 'delete',
      selectData: [],
      sureCode: ['delete', 'enable', 'disable']
    }
  },
  computed: {
    orderTimeClass() {
      return this.orderType === 'DESC'
        ? 'el-icon-caret-bottom'
        : 'el-icon-caret-top'
    },
    selectedIds() {
      return this.selectData.map(item => item.id).join(',')
    },
    selectedLength() {
      return this.selectData.length || 0
    },
    getParams() {
      return Object.assign({}, this.selfDefinedParams, {
        orderType: (this.isSupportSort && this.isShowOperate) ? this.orderType : undefined,
        page: this.page,
        pageSize: this.$attrs.pagesize
      })
    },
    tips() {
      if (this.handleCode === 'delete') return '确认是否删除？'
      else if (this.handleCode === 'enable') return '确认是否启用？'
      return '确认是否禁用？'
    }
  },
  created() {},
  mounted() {
    if (this.isInitList) {
      this.transmitParams()
    }
  },
  methods: {
    sortData() {
      this.orderType = this.orderType === 'DESC' ? 'ASC' : 'DESC'
      this.resetList()
    },
    resetPage() {
      this.page = 1
      this.$refs.cypagination.page = 1
    },
    resetList() {
      this.resetPage()
      this.transmitParams()
    },
    handleCurrentChange(val) {
      this.page = val
      this.transmitParams()
    },
    // 传递参数
    transmitParams() {
      this.$emit('transmitParams', this.getParams)
    },
    // 操作栏
    handleCommand(code) {
      if (this.sureCode.indexOf(code) !== -1) {
        this.handleCode = code
        this.$refs.deleteDialog.cyDialogCommon = true
        return false
      }
      this.$emit('handleCommand', code)
    },
    handleSelectionChange(val) {
      this.selectData = [...val]
    },
    // 删除确认
    dialogDeleteSure() {
      this.$emit('dialogDeleteSure', {
        ids: this.selectedIds,
        mode: this.handleCode
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dataCenter-common-list {
  &_operate {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    height: 25px;
    /deep/ .operate-btn {
      float: none;
      margin: 0;
    }
    .sort {
      flex-shrink: 0;
      line-height: 25px;
      font-size: 12px;
      cursor: pointer;
    }
  }
  /deep/ .el-table {
    @extend .comBackground;
  }
}
.deleteDialog {
  /deep/ .cy-dialog-common {
    .el-dialog__body {
      padding-bottom: 10px;
      .delete-icon-box {
        width: 60px;
        height: 60px;
        background-color: #f3c245;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 25px;
      }
      .delete-text {
        text-align: center;
      }
    }
  }
}
</style>
